export type AdminMenuSubItem = {
    label: string;
    href: string;
};

export type AdminMenuItem = {
    label: string;
    href?: string;
    subItems?: AdminMenuSubItem[];
};

export const adminMenuItems: AdminMenuItem[] = [
    { label: 'ACCOUNTS', href: 'https://helpgang.iam.rio.cloud/#/accounts' },
    { label: 'PARTNER INTEGRATIONS', href: 'https://helpgang.iam.rio.cloud/#/partner-integrations' },
    { label: 'CLIENT METRICS', href: 'https://helpgang.iam.rio.cloud/#/client-metrics' },
    { label: 'ASSETS', href: 'https://helpgang.assets.rio.cloud/#/assets' },
    { label: 'DEVICE STATE', href: 'https://helpgang.assets.rio.cloud/#/device-state' },
    { label: 'INBOUND CONNECTIONS', href: 'https://helpgang.iam.rio.cloud/#/inbound-connections' },
    {
        label: 'ACTIVATION',
        subItems: [
            { label: 'Activation', href: 'https://admin.marketplace.rio.cloud/activation/activations' },
            { label: 'Free Trial', href: 'https://admin.marketplace.rio.cloud/activation/free-trial' },
            {
                label: 'Integrated Offer - Packages',
                href: 'https://admin.marketplace.rio.cloud/activation/integrated-offer/packages',
            },
            {
                label: 'Integrated Offer - Booking Intents',
                href: 'https://admin.marketplace.rio.cloud/activation/integrated-offer/booking-intents',
            },
            { label: 'Utilities', href: 'https://admin.marketplace.rio.cloud/activation/utilities' },
        ],
    },
    { label: 'BILLING', href: 'https://admin.marketplace.rio.cloud/billing' },
    { label: 'IOT EVENTS', href: 'https://helpgang.assets.rio.cloud/#/iot-events' },
    { label: 'RENTAL', href: 'https://helpgang.assets.rio.cloud/#/rental' },
    { label: 'TRANSPORT ORDERS', href: 'https://webtms.rio.cloud/rio-admin/transport-orders' },
];
